import { render } from "./card-selector-v2.vue?vue&type=template&id=45d43b9e&ts=true"
import script from "./card-selector-v2.vue?vue&type=script&lang=ts"
export * from "./card-selector-v2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__